import { Injectable } from "@angular/core";
import { SubmissionDetailsActionsService } from "./submission-details-actions.service";
import { ApplicationDocumentData } from "../../../domain/models/application.model";
import { SubmissionsFacade } from "../../../domain/+state/submissions.facade";
import { NotInterestedActionCompletedData } from "../../not-interested-action/not-interested-action.model";
import { AppPageService } from "common";
import { merge, Observable } from "rxjs";
import { mapTo, tap } from "rxjs/operators";

@Injectable()
export class SubmissionDetailsHandleSharedActionsService {
  constructor(
    private readonly actionsService: SubmissionDetailsActionsService,
    private readonly submissionsFacade: SubmissionsFacade,
    private readonly appPageService: AppPageService,
  ) { }

  watchCommonActions(): Observable<void> {
    return merge(
      this.actionsService.close$.pipe(
        tap(() => this.onClose()),
        mapTo(undefined)
      ),
      this.actionsService.notInterestedActionComplete$.pipe(
        tap((data) => this.onNtInterestedActionComplete(data)),
        mapTo(undefined)
      ),
      this.actionsService.downloadApplicationDocument$.pipe(
        tap((data) => this.onDownloadApplicationDocument(data)),
        mapTo(undefined)
      ),
      this.actionsService.redirectCustomerOfferDetailsView$.pipe(
        tap((data) => this.onRedirectCustomerOfferDetailsView(data)),
        mapTo(undefined)
      )
    );
  }

  private onClose(): void {
    this.appPageService.back();
  }

  private onDownloadApplicationDocument(data: ApplicationDocumentData): void  {
    this.submissionsFacade.downloadApplicationDocument(data.applicationId, data.id, data.filename).subscribe();
  }

  private onNtInterestedActionComplete(data: NotInterestedActionCompletedData): void {
    if (data.isSuccess) {
      this.appPageService.back();
    }
  }

  private onRedirectCustomerOfferDetailsView(detailsPreviewUrl: string): void {
    window.open(detailsPreviewUrl, "_blank");
  }
}
